module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v("Izvešaj vozača")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "form-label"
  }, [_vm._v("Od: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Od: ",
      "name": "email"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "change": _vm.changedDateFrom,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label"
  }, [_vm._v("Do: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Do: ",
      "name": "email"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "change": _vm.changedDateTo,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "background": "#2b542c",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.getReport()
      }
    }
  }, [_c('i', {
    staticClass: "ti-search"
  }), _vm._v("  Zatraži izveštaj\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.schedules.length > 0) ? _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "background": "cornflowerblue",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.generateExcelFile(false)
      }
    }
  }, [_c('i', {
    staticClass: "ti-download"
  }), _vm._v("  Skini excel\n            ")]) : _vm._e(), _vm._v(" "), (_vm.schedules.length > 0) ? _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "background": "cornflowerblue",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.generateExcelFile(true)
      }
    }
  }, [_c('i', {
    staticClass: "ti-download"
  }), _vm._v("  Skini pdf\n            ")]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "90%",
      "border-radius": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pretraga",
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredUsers), function(obj, index) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(obj.lastName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.round(obj.ordersPriceAmount)))]), _vm._v(" RSD")]), _vm._v(" "), (obj.voucher === '' || obj.voucher == null) ? _c('td', [_vm._v("-")]) : _vm._e(), _vm._v(" "), (obj.voucher != null && obj.voucher !== '') ? _c('td', _vm._l((_vm.getVouchers(obj.voucher)), function(obj) {
      return _c('span', [_vm._v("\n                                    " + _vm._s(obj.count) + "\n                                    "), (obj.voucher === 'VOUCHER_GREEN') ? _c('img', {
        staticStyle: {
          "width": "20px",
          "height": "20px"
        },
        attrs: {
          "src": require("../../assets/img/coin.png")
        }
      }) : _vm._e(), _vm._v(" "), (obj.voucher === 'VOUCHER_BLUE') ? _c('img', {
        staticStyle: {
          "width": "20px",
          "height": "20px"
        },
        attrs: {
          "src": require("../../assets/img/coin_blue.png")
        }
      }) : _vm._e(), _vm._v(" "), (obj.voucher === 'VOUCHER_WHITE') ? _c('img', {
        staticStyle: {
          "width": "20px",
          "height": "20px"
        },
        attrs: {
          "src": require("../../assets/img/coin_white.png")
        }
      }) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.round(obj.ordersPriceAmount - _vm.checkNull(obj.wage) - _vm.checkNull(obj.costs) - _vm.checkNull(obj.expense))))]), _vm._v(" RSD")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.round(_vm.checkNull(obj.costs))) + " RSD / " + _vm._s(_vm.round(_vm.checkNull(obj.expense))) + " RSD")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.round(_vm.checkNull(obj.wage))) + " RSD")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('b', [_vm._v(_vm._s(obj.workingDays))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.displayHoursAndMinutes(obj.workMinutes)))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('b', [_vm._v(_vm._s(obj.ordersNumber))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.roundWhole(_vm.checkNull(obj.averageByOrder))))])])])
  }), 0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "40px",
      "color": "white"
    }
  }, [_vm._v("R. br")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Vozač")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Ukupan pazar")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px",
      "color": "white"
    }
  }, [_vm._v("Kuponi")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Ukupna zarada")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Utrošak gorivo/rashod")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Ukuopno dnevnice")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Radnih dana")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Radni sati (HH:MM)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "300px",
      "color": "white"
    }
  }, [_vm._v("Br. porudžbina")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "300px",
      "color": "white"
    }
  }, [_vm._v("Prosek (min)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6dd3dc5b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Report/ScheduleReport.vue
// module id = 492
// module chunks = 1